// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { OrganizationRoleManagement, OrganizationRoleManagementSchema } from 'api/gen/OrganizationRoleManagement';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  isSubjectMember: t.boolean,
  roles: t.array(OrganizationRoleManagementSchema),
  userProfileId: t.Integer,
  username: UsernameSchema,
});

export const UserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema = excess(requiredPart);

export interface UserProfileSubjectRoleManagementDtoOrganizationRoleManagement extends t.TypeOf<typeof UserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema> {}
